import React from 'react';
import { Box, Flex, Text } from '@marvelapp/ui';
import SelectAllCheckbox from '../SelectAllCheckbox';
function Actions({ allItems, children, clearSelectedItems, selectAllItems, selectedItems, }) {
    const selectedItemsCount = selectedItems.length;
    return (React.createElement(Flex, { alignItems: "center", flex: 1, height: "100%", pl: [3, 3, 4] },
        allItems && (React.createElement(Box, { mr: 3 },
            React.createElement(SelectAllCheckbox, { allItems: allItems, clearSelectedItems: clearSelectedItems, kind: "defaultGreenReversed", selectAllItems: selectAllItems, selectedItems: selectedItems, size: 20, tooltipPosition: "topLeft" }))),
        React.createElement(Text, { color: "white", "data-testid": "selected-items", fontSize: 3, mr: [3, 3, 4], pt: "1px", tag: "div" },
            React.createElement(Text, { color: "white", display: "inline", fontWeight: 600 }, selectedItemsCount),
            ' ',
            "selected"),
        children));
}
export default Actions;
